import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ReceiptAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 2H4C3.4 2 3 2.4 3 3V21C3 21.6 3.4 22 4 22C4.2 22 4.4 21.9 4.6 21.8L6.7 20.3L8.8 21.8C9.2 22.1 9.6 22.1 10 21.8L12.1 20.3L14.2 21.8C14.6 22.1 15 22.1 15.4 21.8L17.5 20.3L19.6 21.8C19.8 21.9 20 22 20.2 22C20.8 22 21.2 21.6 21.2 21V3C21 2.4 20.6 2 20 2ZM16 16H8C7.4 16 7 15.6 7 15C7 14.4 7.4 14 8 14H16C16.6 14 17 14.4 17 15C17 15.6 16.6 16 16 16ZM16 12H8C7.4 12 7 11.6 7 11C7 10.4 7.4 10 8 10H16C16.6 10 17 10.4 17 11C17 11.6 16.6 12 16 12ZM16 8H10C9.4 8 9 7.6 9 7C9 6.4 9.4 6 10 6H16C16.6 6 17 6.4 17 7C17 7.6 16.6 8 16 8Z"
      fill="currentColor"
    />
  </svg>
)

export default ReceiptAlt
